import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { CLOUDINARY_NAME } from '../../../containers/CreateACard'
import { Image, Transformation } from 'cloudinary-react'

const useStyles = makeStyles((theme) => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}))

const GreetingCardImageModal = (props) => {
    const { modalIsOpen } = props
    const classes = useStyles()
    const theme = useTheme()
    return (
        <React.Fragment>
            <Dialog
                id="greeting-card-image-modal"
                maxWidth={'lg'}
                open={modalIsOpen}
                onClose={props.closeModal}
                aria-labelledby="Greeting Card"
            >
                <DialogTitle id="max-width-dialog-title">
                    <IconButton
                        data-testid="close-button"
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={props.closeModal}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        spacing={2}
                        style={{
                            padding: '1rem',
                        }}
                    >
                        <Grid item xs={12}>
                            <Image
                                cloudName={CLOUDINARY_NAME}
                                publicId={'GCG/assets/bac-greeting-card-thanks'}
                                width={'100%'}
                                height={'auto'}
                            >
                                <Transformation fetchFormat="auto" />
                            </Image>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default GreetingCardImageModal
